import { CsvBuilder } from "filefy";

// const getNestedValue = (obj, path) => {
//     return path.split('.').reduce((acc, part) => acc?.[part], obj);
// };

const getNestedValue = (obj, path) => {
    const value = path.split('.').reduce((acc, part) => acc?.[part], obj);
    
    if (Array.isArray(value))
        return value.join(', ');
    
    return value ?? '';
};

export const exportCsv = (filename) => (columns, data) => {
    const columnsToExport = columns.filter(columnDef => columnDef["export"] !== false);

    const exportedData = data.map(rowData =>
        columnsToExport.map(columnDef => getNestedValue(rowData, columnDef.field) ?? "")
    );

    const csvBuilder = new CsvBuilder(filename)
        .setColumns(columnsToExport.map(columnDef => columnDef.title))
        .addRows(exportedData);

    csvBuilder.exportFile();
};